import {
  CartItemResultFragment,
  CartItemFragment,
  GetCartQuery,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { getNormalizedCartProduct } from './normalized-cart-product'
import { CartBaseProduct } from './cart-base-product-types'
export const OptimisticResponseCartItemId = -1

export const upsertCartCacheWithNewItems = (
  cart: GetCartQuery['cart'],
  newData: CartItemResultFragment[]
) => {
  const cartItems = [...(cart?.items || [])]

  const resultItems = newData || []
  const updatedItems = cart && cartItems
  if (cart && resultItems && updatedItems) {
    resultItems.forEach(resultItem => {
      const resultCartItem: CartItemFragment = {
        ...resultItem,
        endUserInformation: null,
        // @ts-ignore
        __typename: 'CartItem',
      }

      const oldItemIndex = updatedItems.findIndex(
        oldItem =>
          oldItem.id === resultItem.id ||
          (oldItem.product?.productErpIdentifier === resultItem.product?.productErpIdentifier &&
            resultItem.mainProductErpIdentifier === oldItem.mainProductErpIdentifier &&
            resultItem.comment === oldItem.comment &&
            (resultItem.parentCartItemId || null) === (oldItem.parentCartItemId || null))
      )

      if (resultCartItem.quantity === 0 && oldItemIndex === -1) {
        return
      }

      if (resultCartItem.quantity === 0) {
        updatedItems.splice(oldItemIndex, 1)
      } else if (oldItemIndex === -1) {
        updatedItems.push(resultCartItem)
      } else {
        updatedItems[oldItemIndex] = resultCartItem
      }
    })

    const updatedData: GetCartQuery = {
      cart: {
        ...cart,
        items: updatedItems,
        // @ts-ignore
        __typename: 'Cart',
      },
    }

    return updatedData
  }
}

export const getOptimisticResponse = ({
  cartItems,
  productErpIdentifier,
  mainProductErpIdentifier,
  quantity,
  product,
  comment,
  parentCartItemId,
}: {
  cartItems: CartItemFragment[]
  productErpIdentifier: string
  mainProductErpIdentifier: string | null
  quantity: number
  product: CartBaseProduct
  comment: string | null | undefined
  parentCartItemId?: number | null
}) => {
  const optimisticResponseIds = cartItems.filter(x => x.id < 0).map(c => c.id)
  const idAppender = optimisticResponseIds.length ? Math.min(...optimisticResponseIds) : undefined

  const normalizedProduct = getNormalizedCartProduct(product)

  const parentCartItem =
    cartItems.find(i => i.id === parentCartItemId) ||
    cartItems.find(i => i.productErpIdentifier === mainProductErpIdentifier)

  const currentCartItem = cartItems.find(
    i =>
      i.productErpIdentifier === productErpIdentifier &&
      i.mainProductErpIdentifier === mainProductErpIdentifier &&
      i.comment === (comment ?? null) &&
      (i.parentCartItemId || null) === (parentCartItemId || null)
  )

  const responseData: CartItemResultFragment[] = [
    {
      id: currentCartItem?.id || OptimisticResponseCartItemId - (idAppender ?? 0),
      isDependent: currentCartItem?.isDependent || false,
      isMandatory: currentCartItem?.isMandatory || false,
      mainProductErpIdentifier: mainProductErpIdentifier,
      parentCartItemId: parentCartItem?.id || 0,
      productErpIdentifier: productErpIdentifier,
      quantity: quantity,
      product: currentCartItem?.product || normalizedProduct,
      comment: currentCartItem?.comment ?? null,
      // @ts-ignore
      __typename: 'CartItemResult',
    },
  ]

  return responseData
}
